import { Currency } from "../models/currency";

export function getFormattedCurrency(value: number, currency?: Currency) {
  if (!currency) {
    return `${new Intl.NumberFormat('en-IN', {
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    }).format(value / 100)}`;
  }
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currencyDisplay: 'symbol',
    currency: currency.toUpperCase(),
  }).format(value / 100)
}